import { ADS_SESSION_STORAGE_KEY } from '../consts';

export const getAdSessionId = (): string => {
  if (typeof window === 'undefined') {
    return '';
  }

  let sessionId = localStorage.getItem(ADS_SESSION_STORAGE_KEY);

  if (!sessionId) {
    sessionId = `ads-${Date.now()}-${Math.random().toString(36).slice(2, 11)}`;
    localStorage.setItem(ADS_SESSION_STORAGE_KEY, sessionId);
  }

  return sessionId;
};

export const getAdImpressionStorageKey = (campaignId: number): string => {
  return `molwe_ads_impression_${campaignId}`;
};
